/* ================================================== */
/* UPDATE QUERY STRING PARAM
/* ================================================== */

var updateQueryStringParam = function (key, value) {
	var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
		urlQueryString = document.location.search,
		newParam = key + '=' + value,
		params = '?' + newParam;

	if (urlQueryString) {
		var updateRegex = new RegExp('([\?&])' + key + '[^&]*'),
			removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

		 // Remove param if value is empty
		if (typeof value == 'undefined' || value == null || value == '') {
			params = urlQueryString.replace(removeRegex, "$1");
			params = params.replace( /[&;]$/, "" );

		// Update param if already exists
		} else if (urlQueryString.match(updateRegex) !== null) {
			params = urlQueryString.replace(updateRegex, "$1" + newParam);

		// Otherwise, add it to end
		} else {
			params = urlQueryString + '&' + newParam;
		}
	}

	// No parameter was set so we don't need the question mark
	params = params == '?' ? '' : params;

	window.history.replaceState({}, "", baseUrl + params);
};